export enum ReadType {
	Unread = 0,
	Read = 1
}